// src/components/SmartNavLink.js
import React from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { Link as ScrollLink, scroller } from 'react-scroll';

// This is our custom hook/component
const SmartNavLink = ({ to, type, children, isMobile, onClose, ...props }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const handleNavAndScroll = (e) => {
    e.preventDefault(); // Prevent default link behavior
    if (isMobile && onClose) onClose(); // Close mobile menu if open

    // Navigate to the homepage, passing the scroll target in the state
    navigate('/', { state: { scrollTo: to } });
  };

  // If it's a link to another page (like /gallery)
  if (type === 'link') {
    return (
      <RouterLink to={to} onClick={isMobile ? onClose : undefined} {...props}>
        {children}
      </RouterLink>
    );
  }

  // If we are already on the homepage, use ScrollLink
  if (isHomePage) {
    return (
      <ScrollLink
        to={to}
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}
        onClick={isMobile ? onClose : undefined}
        style={{ cursor: 'pointer' }}
        {...props}
      >
        {children}
      </ScrollLink>
    );
  }

  // If we are NOT on the homepage, use a link that will navigate home first
  return (
    <a href={`/#${to}`} onClick={handleNavAndScroll} style={{ cursor: 'pointer' }} {...props}>
      {children}
    </a>
  );
};

export default SmartNavLink;